import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { BadgePill } from "./BadgePill";
import { StatusLight } from "./StatusLight";

const roleToBadge = {
  admin: 'primary',
  president: 'success',
  member: 'default',
  pledge: 'muted',
  alumni: 'warning',
};

export const MemberCard = ({ 
  name, 
  email,
  avatar,
  role = 'member',
  status = 'active',
  joinDate,
  onClick,
  className 
}) => {
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div 
      className={cn(
        "bg-graphite rounded-xl border border-white/[0.06] p-4 transition-all duration-200",
        "hover:border-white/[0.12] hover:bg-graphite/80 cursor-pointer",
        className
      )}
      onClick={onClick}
      data-testid="member-card"
    >
      <div className="flex items-center gap-4">
        <Avatar className="h-12 w-12 border border-white/[0.06]">
          {avatar ? (
            <AvatarImage src={avatar} alt={name} />
          ) : null}
          <AvatarFallback className="bg-obsidian text-soft-silver text-sm">
            {initials}
          </AvatarFallback>
        </Avatar>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="text-cloud-white font-medium truncate">{name}</h4>
            <BadgePill variant={roleToBadge[role]}>
              {role.charAt(0).toUpperCase() + role.slice(1)}
            </BadgePill>
          </div>
          
          <div className="flex items-center gap-3 text-sm">
            {email && (
              <span className="text-muted-text truncate">{email}</span>
            )}
          </div>
        </div>
        
        <StatusLight status={status} />
      </div>
      
      {joinDate && (
        <div className="mt-3 pt-3 border-t border-white/[0.06]">
          <span className="text-xs text-muted-text">
            Joined <span className="font-mono">{joinDate}</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default MemberCard;
